import React from 'react';

import { SettableValueParams } from 'types/PropsWithSettableValue';

import { ValueProp } from './valueProp';

/**
 * Конфиг complexOnClick позволяет однозначно разделить действия вида onClick(event) / onChange(value)
 * - Используется в кнопке и в дефолтных HTML-тегах
 **/
export type WithComplexOnClick<V extends ValueProp> = {
  complexOnClick:
    | {
        onClick: React.MouseEventHandler<HTMLElement>;
      }
    | SettableValueParams<V>;
};

/**
 * Является ли данный экшен таким, который содержит complexOnClick
 */
export const isWithComplexOnClick = <V extends ValueProp>(
  action: any
): action is WithComplexOnClick<V> =>
  Boolean(action && 'complexOnClick' in action);
